import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function usePublicSprites() {
  const [sprites, setSprites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`${API}/sprites/public`, { timeout: 20000 });
      setSprites(res.data || []);
    } catch (e) {
      setError(e?.response?.data?.detail || e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const publish = useCallback(async (payload) => {
    const res = await axios.post(`${API}/sprites/public`, payload, { timeout: 30000 });
    setSprites((prev) => [res.data, ...prev]);
    return res.data;
  }, []);

  const vote = useCallback(async (spriteId, userId) => {
    const res = await axios.post(`${API}/sprites/public/${spriteId}/vote`, { user_id: userId });
    setSprites((prev) => {
      const next = prev.map((s) => (s.id === spriteId ? res.data : s));
      next.sort((a, b) => b.vote_count - a.vote_count || b.created_at.localeCompare(a.created_at));
      return next;
    });
    return res.data;
  }, []);

  const unpublish = useCallback(async (spriteId, ownerId) => {
    await axios.delete(`${API}/sprites/public/${spriteId}`, { params: { owner_id: ownerId } });
    setSprites((prev) => prev.filter((s) => s.id !== spriteId));
  }, []);

  return { sprites, loading, error, refresh, publish, vote, unpublish };
}
